import React from 'react';
import { graphql, compose } from 'react-apollo';
import { Auth } from 'aws-amplify';

import Backlog from 'Components/Presentation/BacklogTasks/Backlog';

import AllBacklogTaskQuery from 'GraphQueries/BacklogTasks/AllQuery';
import NewBacklogTaskMutation from 'GraphQueries/BacklogTasks/NewMutation';
import UpdateBacklogTaskMutation from 'GraphQueries/BacklogTasks/UpdateMutation';
import AllAdvertisersQuery from 'GraphQueries/Advertisers/AllQuery';
import AllCampaignsQuery from 'GraphQueries/Campaigns/AllQuery';

const columns = [{ id: 'todo', title: 'To Do' }, { id: 'inprogress', title: 'In Progress' }, { id: 'complete', title: 'Completed' }];

class BacklogTaskContainer extends React.Component {

    static defaultProps = {
        projectTasks: []
    }
    state = { saving: false }

    handleTaskCreate = backlogTask => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(backlogTask).then(x => {
            onAlert('success', `Successfully created backlog task: ${backlogTask.name}`);
            this.setState({ saving: false });
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to create backlog tasks, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: false });
        })
    }

    assignTaskToUser = async task => {
        let userToken = (await Auth.currentSession()).getIdToken();
        const { payload: { sub } } = userToken;
        this.doUpdate({ id: task.id, userId: sub })
    }

    handleTaskUpdate = result => {
        this.doUpdate({ id: result.draggableId, status: result.destination.droppableId });
    }

    doUpdate = task => {
        const { onUpdate, onAlert } = this.props;
        this.setState({ saving: true });
        onUpdate(task).then(x => {
            onAlert('success', `Successfully updated backlog task: ${task.id}`);
            this.setState({ saving: false });
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to update backlog tasks, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: false });
        });
    }
    
    render() {
        const { projectTasks, loading, advertisers, campaigns, advertisersLoading, campaignsLoading } = this.props;
        return <Backlog columns={columns} tasks={projectTasks} userAssignmentHandler={this.assignTaskToUser}
            loading={loading || advertisersLoading || campaignsLoading || this.state.saving} advertisers={advertisers} campaigns={campaigns}
            saveHandler={this.handleTaskCreate} updateHandler={this.handleTaskUpdate} />;
    }
}

export default 
    compose(
        graphql(AllBacklogTaskQuery(['status', 'details', 'user { firstName, lastName }']), {
            props: ({ data: { listTasks, loading } }) => ({ projectTasks: listTasks && listTasks.items, loading })
        }),
        graphql(AllAdvertisersQuery(), {
            props: ({ data }) => ({ advertisers: data.listAdvertisers && data.listAdvertisers.items, advertisersLoading: data.loading }),
        }),
        graphql(AllCampaignsQuery(['advertiserId']), {
            props: ({ data: { listCampaigns, loading } }) => ({ campaigns: listCampaigns && listCampaigns.items, campaignsLoading: loading })
        }),
        graphql(UpdateBacklogTaskMutation(['status']), {
            options: () => ({ refetchQueries: [{ query: AllBacklogTaskQuery(['status', 'details', 'user { firstName, lastName }']) }] }),
            props: ({ mutate }) => ({
                onUpdate: input => {
                    return mutate({
                        variables: { input }, optimisticResponse: () => ({
                            updateTask: {
                                ...input,
                                __typename: 'Task'
                            }
                        })
                    });
                }
            })
        }), 
        graphql(NewBacklogTaskMutation(), {
            options: () => ({ refetchQueries: [{ query: AllBacklogTaskQuery(['status', 'details', 'user { firstName, lastName }']) }] }),
            props: ({ mutate }) => ({
                onAdd: input => mutate({
                    variables: { input }, optimisticResponse: () => ({
                        createTask: {
                            ...input,
                            __typename: 'Task'
                        }
                    })
                })
            })
        })
    )(BacklogTaskContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Backlog/Index.js